import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import CustomerDashboard from "../../components/CustomerDashboard/CustomerDashboard";
import Langtrans from "../../components/Langtrans/Langtrans";
import Buttons from "../../components/Button/Button";
import "./Dashboard.scss";
import { API, graphqlOperation } from "aws-amplify";
import { campaignData, productData, draftId } from "../../store/action";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import SignalCellularAltOutlinedIcon from "@mui/icons-material/SignalCellularAltOutlined";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";
import { useSelector, useDispatch } from "react-redux";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import { deleteProductTable } from "../../graphql/mutations";
import { useHistory } from "react-router-dom";
import Snackbar from "../../components/Snackbar/Snackbar";
import Tooltip from "@mui/material/Tooltip";
import moment from "moment";
import ViralLoops from "viral-loops-react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const Home = () => {
  const [shirtsdata3, setshirtdata3] = useState("");

  const { t } = useTranslation();
  const history = useHistory();
  const { pathname } = useLocation();
  const login = useSelector((state) => state.login);
  const campaign = useSelector((state) => state.campaign.campaign);
  const addtocart = useSelector((state) => state.campaign.addtocart);
  const dispatch = useDispatch();
  const [product, setProduct] = useState([]);
  const [msg, setMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [ordersQuan, setordersQuan] = useState(0);
  const [orderGains, setorderGains] = useState(0);
  const [totGains, settotGains] = useState(0);
  useEffect(() => {
    dispatch(
      draftId({
        draftProductId: "",
      })
    );
    dispatch(
      productData({
        id: "",
        step: 0,
        shirt: {},
        designnimg: "",
        color: "",
        realprice: 0,
        price: 0,
        day: 0,
        sales: 0,
        shirtname: "",
        brief: "",
        detail: "",
        campaign: 0,
        shirtdesign: [],
        shirtdesignback: [],
        frontDesignObj: null,
        backDesignObj: null,
        alterImage: null,
        edit: false,
        hello: {},
        seldata: false,
        shirtsdata1: "",
        shirtsdata2: "",
        designnimgback: "",
      })
    );
  }, []);

  const remainDate = (createdAt, days) => {
    if (product) {
      const currentDate = moment(createdAt, "YYYY-MM-DD");
      const futureDate = moment(currentDate._d).add(days, "days");
      const endDate = moment(futureDate._d).format("YYYY-MM-DD");
      const todaysdate = moment();
      return moment(endDate).diff(todaysdate, "days");
    }
  };
  const handleGuide = () => {
    const win = window.open(
      "https://www.laetus-store.com/guide-du-createur",
      "_blank"
    );
    win.focus();
  };

  const AddtoCart = (data) => {
    const exist = campaign?.find((item) => item.id === data?.id);
    if (exist) {
      history.push("/order");
      dispatch(
        campaignData({
          campaign: campaign.map((x) =>
            x.id === data?.id ? { ...exist, quantity: exist.quantity + 1 } : x
          ),
        })
      );
    } else {
      history.push("/order");
      dispatch(
        campaignData({
          campaign: [...campaign, { ...data, quantity: 1 }],
        })
      );
    }
  };
  const designroute = () => {
    dispatch(
      draftId({
        draftProductId: "",
      })
    );
    dispatch(
      productData({
        id: "",
        step: 0,
        shirt: {},
        designnimg: "",
        color: "",
        realprice: 0,
        price: 0,
        day: 0,
        sales: 0,
        shirtname: "",
        brief: "",
        detail: "",
        campaign: 0,
        shirtdesign: [],
        shirtdesignback: [],
        frontDesignObj: null,
        backDesignObj: null,
        alterImage: null,
        edit: false,
        hello: {},
        seldata: false,
        shirtsdata1: "",
        shirtsdata2: "",
        designnimgback: "",
      })
    );
    history.push("/");
  };

  // function toDataURL(url, callback) {
  //   var xhr = new XMLHttpRequest();
  //   xhr.onload = function () {
  //     var reader = new FileReader();
  //     reader.onloadend = function () {
  //       callback(reader.result);
  //     };
  //     reader.readAsDataURL(xhr.response);
  //   };
  //   url += "?" + new Date().getTime();
  //   xhr.open("GET", url);
  //   xhr.responseType = "blob";
  //   xhr.send();
  // }

  // const selShirt = async (data) => {
  //   await toDataURL(data?.shirtDesignFront, async function (myBase64) {
  // const url = myBase64;
  // setshirtdata3(
  //   "data:" ==
  //     (myBase64 &&
  //       myBase64.replace(
  //         "data:binary/octet-stream;base64,",
  //         "data:image/png;base64,"
  //       ))
  // );
  // return url;
  // });
  // await toDataURL(data?.shirtDesignBack, async function (myBase64) {
  // 	return (
  // 		myBase64 &&
  // 		myBase64.replace(
  // 			"data:binary/octet-stream;base64,",
  // 			"data:image/png;base64,",
  // 		)
  // 	);
  // });
  // };
  // const convert = async (item) => {
  //   const res = await selShirt(item);
  //   console.log("==>", res);
  // };

  // useEffect(() => {
  //   convert();
  // }, []);
  // useEffect(() => {
  //   console.log("shirtsdata3", shirtsdata3);
  // }, [shirtsdata3]);
  const calData = async () => {
    if (campaign.length) {
      const { price, quantity } = campaign
        .map((item) => {
          const quantity = item?.orders?.items?.reduce((prev, curr) => {
            prev += Number(curr?.quantity || 0);
            return prev;
          }, 0);
          const price =
            // (item.backDesignBack !== "" &&
            // item.shirtDesignBack !== "" &&
            // quantity * Number(item.sellingPrice - item.realprice) !== 0
            //   ? 5
            //   : 0) +
            quantity * Number(item.sellingPrice - item.realprice);
          return {
            quantity,
            price,
          };
        })
        .reduce(
          (acc, item) => {
            acc.quantity += item.quantity || 0;
            acc.price += item.price || 0;

            return acc;
          },
          { price: 0, quantity: 0 }
        );

      const { totalgain } = campaign
        .map((item) => {
          if (item?.orders?.items?.length > 4) {
            const quantityforgains = item?.orders?.items?.reduce(
              (prev, curr) => {
                prev += Number(curr?.quantity || 0);
                return prev;
              },
              0
            );
            const totalgain =
              // (item.backDesignBack !== "" &&
              // item.shirtDesignBack !== "" &&
              // quantityforgains * Number(item.sellingPrice - item.realprice) !==
              //   0
              //   ? 5
              //   : 0) +
              quantityforgains * Number(item.sellingPrice - item.realprice);
            return {
              totalgain,
            };
          }
        })
        .reduce(
          (acc, item) => {
            // console.log(acc, item);
            acc.totalgain += item?.totalgain || 0;
            return acc;
          },
          { totalgain: 0 }
        );
      setordersQuan(quantity);
      setorderGains(price);
      settotGains(totalgain);
    }
  };
  useEffect(() => {
    calData();
  }, [campaign.length]);

  const orderdata = (data) => {
    const quantity = [];
    data.map((item) => {
      quantity.push(Number(item.quantity));
    });
    const quantityData = quantity?.reduce((x, y) => x + y);
    return quantityData;
  };

  return (
    <>
      <div className="home">
        <div className="left">
          <CustomerDashboard />
        </div>
        <div className="right">
          <div className="top">
            <h4>{t("home")}</h4>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-arround",
              }}
            >
              <Buttons
                style={{ width: "180px", marginRight: "0px" }}
                text={t("new-campaign")}
                onClick={() => designroute()}
              />
              <Langtrans
                style={{ marginRight: "0px", marginTop: "0px", height: "36px" }}
                dashboard
              />
            </div>
          </div>
          <div className="bottom" style={{ height: "121%" }}>
            <hr />
            <div className="bottom-top">
              <div className="card">
                <p>
                  <b>{t("recap")}</b>
                </p>
                <div className="cal-div" style={{ textAlign: "center" }}>
                  <div>
                    <h1>{ordersQuan}</h1>
                    <p>
                      <b>{t("pre-order")}</b>
                    </p>
                  </div>
                  <div>
                    <h1>{totGains}€</h1>
                    <p>
                      <b>{t("potential")}</b>
                    </p>
                  </div>
                  <div>
                    <h1>{orderGains}€</h1>
                    <p>
                      <b>{t("valides")}</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {campaign.length > 0 ? (
              <>
                <table
                  style={{ width: "100%", textAlign: "left" }}
                  CELLSPACING="0"
                  CELLPADDING="0"
                >
                  <thead>
                    <tr>
                      <th style={{ width: "350px" }}>
                        <div
                          style={{
                            textTransform: "uppercase",
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            {t("cur-campaign")}
                          </h3>
                        </div>
                      </th>
                      <th style={{ width: "250px", fontFamily: "Roboto" }}>
                        <small>
                          <b>{t("remain-time")}</b>
                        </small>
                      </th>
                      <th style={{ fontFamily: "Roboto" }}>
                        <small>
                          <b>{t("nb-pre-orders")}</b>
                        </small>
                      </th>
                      <th style={{ fontFamily: "Roboto" }}>
                        <small>
                          <b>{t("gains")}</b>
                        </small>
                      </th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <hr />
                      </td>
                      <td>
                        <hr />
                      </td>
                      <td>
                        <hr />
                      </td>
                      <td>
                        <hr />
                      </td>
                      <td>
                        <hr />
                      </td>
                      <td>
                        <hr />
                      </td>
                    </tr>
                    {/* slice(0, 4) */}
                    {campaign.length > 0 ? (
                      campaign.map((data, ind) => {
                        return (
                          !data.isStop &&
                          data.isDone &&
                          remainDate(data.createdAt, data.days) + 1 > 0 && (
                            <>
                              <tr className="cp">
                                <td
                                  onClick={() =>
                                    history.push(`/compaigndetail/${data.id}`)
                                  }
                                >
                                  <td>
                                    <img
                                      src={data.designShirt}
                                      width={80}
                                      height={100}
                                      style={{ marginRight: "20px" }}
                                      alt="design shirt"
                                    />
                                  </td>
                                  <td style={{ fontWeight: "bold" }}>
                                    {data.shirtName}
                                  </td>
                                </td>
                                <td
                                  onClick={() =>
                                    history.push(`/compaigndetail/${data.id}`)
                                  }
                                >
                                  <td>
                                    <small>
                                      {remainDate(data.createdAt, data.days) <
                                      0 + 1
                                        ? 0
                                        : remainDate(
                                            data.createdAt,
                                            data.days
                                          ) + 1}
                                      {t("d")}
                                    </small>
                                  </td>
                                  <td>
                                    <small style={{ marginLeft: "5px" }}>
                                      {t("remain")}
                                    </small>
                                  </td>
                                </td>
                                <td
                                  onClick={() =>
                                    history.push(`/compaigndetail/${data.id}`)
                                  }
                                >
                                  <small>
                                    {data?.orders?.items?.length
                                      ? orderdata(data?.orders?.items)
                                      : 0}{" "}
                                    {t("pre-order")}
                                  </small>
                                </td>
                                <td
                                  onClick={() =>
                                    history.push(`/compaigndetail/${data.id}`)
                                  }
                                >
                                  <small>
                                    {data?.orders?.items?.length
                                      ? orderdata(data?.orders?.items) *
                                        (data?.sellingPrice - data?.realprice)
                                      : 0}{" "}
                                    €
                                  </small>
                                </td>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "35px",
                                  }}
                                >
                                  <td
                                    className="cp"
                                    style={{
                                      border: "1px solid #000",
                                      height: "40px",
                                      padding: "0px 9px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      width: "230px",
                                      background: "#fff",
                                    }}
                                    onClick={() => AddtoCart(data)}
                                  >
                                    <td>
                                      <td>
                                        <ShoppingBagOutlinedIcon />
                                      </td>
                                      <td>
                                        <small>{t("prototype")}</small>
                                      </td>
                                    </td>
                                  </td>
                                </td>
                                <td
                                  className="icons cp"
                                  style={{ textAlign: "end" }}
                                  onClick={() =>
                                    history.push(`/compaigndetail/${data.id}`)
                                  }
                                >
                                  <Tooltip
                                    title={t("analytics")}
                                    arrow
                                    placement="top"
                                  >
                                    <SignalCellularAltOutlinedIcon />
                                  </Tooltip>
                                </td>
                              </tr>
                            </>
                          )
                        );
                      })
                    ) : (
                      <h1 style={{ textAlign: "center", margin: "20px 0px" }}>
                        No data
                      </h1>
                    )}
                  </tbody>
                </table>
                {campaign && campaign.length > 0 && (
                  <div style={{ textAlign: "center" }}>
                    <Buttons
                      text={t("plus")}
                      className="buttons"
                      onClick={() => history.push("/campaign")}
                    />
                  </div>
                )}
              </>
            ) : (
              <h1 style={{ textAlign: "center", margin: "180px 0px" }}></h1>
            )}
            <div className="bot-card">
              <div className="bot-card-left">
                <div onClick={() => handleGuide()} className="cp">
                  <img
                    src="https://st.depositphotos.com/1744418/1887/i/600/depositphotos_18876913-stock-photo-open-book-in-the-library.jpg"
                    width={400}
                    height={402}
                    alt="img"
                    style={{ marginTop: "2px" }}
                  />
                </div>
                <div className="bot-card-left-right">
                  <h3 onClick={() => handleGuide()} className="cp">
                    LE GUIDE DU CREATEUR
                  </h3>
                  <p>
                    Tous nos conseils pour préparer, vendre et réussir votre
                    campagne sur LAETUS.
                  </p>
                  <Buttons text={t("read")} onClick={() => handleGuide()} />
                </div>
              </div>
              <div className="bot-card-left-left">
                <ViralLoops
                  publicToken="UVigRNmD6jChynP12cWT1KYnuS0"
                  formWidget
                  milestoneWidget
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {msg || errMsg ? <Snackbar message={msg} errMessage={errMsg} /> : null}
    </>
  );
};
export default Home;
